import React from "react";
import { Skeleton } from "antd";
import styled from "styled-components";

const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #f5f5f5;
`;

const ROW_COUNT = 8;

// Placeholder rows shown while the initial chat sessions query is still loading, so the list
// doesn't render as an empty state (which reads as "no chats") before data has arrived.
const ChatListSkeleton = React.memo(function ChatListSkeleton() {
  return (
    <div>
      {Array.from({ length: ROW_COUNT }, (_, index) => (
        <SkeletonRow key={index}>
          <Skeleton.Avatar active size="default" shape="circle" />
          <Skeleton
            active
            title={{ width: "60%" }}
            paragraph={{ rows: 1, width: "85%" }}
            avatar={false}
            style={{ flex: 1 }}
          />
        </SkeletonRow>
      ))}
    </div>
  );
});

export default ChatListSkeleton;
